<template>
  <div class="container-pay">
    <div class="custom-nav-block" :style="`paddingTop:${barHeight}px`">
      <van-nav-bar class="van-bar" :title="$t('lang.BaseCommon.k091')" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" @click-left="closeWeb" />
        </template>
        <template #right>
          <div class="coin">
            <img :src="getMatchImg('coin')" alt="" />
            <i>{{ userInfo.coinsNum }}</i>
          </div>
        </template>
      </van-nav-bar>
    </div>

    <div class="main" v-if="!loadingFlag">
      <!-- Select amount -->
      <div class="title">{{ $t('lang.BaseCommon.k092') }}</div>
      <div class="recharge">
        <div v-for="item in coinsProductList" :key="item.gid" class="option" :class="{ selectAct: selectGid == item.gid }" @click="handleSelectCoins(item)">
          <img v-if="item.label" class="best-img" :src="item.label | imgPath" />
          <!-- 档位cost -->
          <div class="option-top">
            <img class="money-img" :src="getMatchImg('coin')" />
            <span>{{ item.amount }}</span>
          </div>
          <!-- 档位gift -->
          <div v-if="item.goodDesc" class="discount-num">
            <div v-for="desItem in handleTipsFormat(item.goodDesc)" :key="desItem.id" class="discount-num-tips">
              <template v-if="desItem.type">
                <span>+{{ desItem.num }}</span>
                <img :src="getMatchImg(desItem.type)" width="13" height="13" />
              </template>
              <template v-else>
                <span>+{{ desItem.origin }}</span>
              </template>
            </div>
          </div>
        </div>
      </div>

      <!-- Payment -->
      <div class="title">{{ $t('lang.BaseCommon.k101') }}</div>
      <!-- 优惠卷入口 -->
      <CouponEnter @openCouponPop="openCouponPop" :maxCoupon="maxCoupon" :styleType="'for-vava'" />
      <!-- 支付方式 -->
      <div
        v-for="(item, index) in payMethodList"
        :key="item.id"
        :class="['method-item', loadingShow ? 'activeLoading' : '', returnDisClass(item.desc, packageName)]"
        @click="handleSelectPay(item, index)"
      >
        <MyPLabel class="discount" v-if="item.desc" :str="item.desc" :customClass="{ coin: 'discount-coins' }" />
        <div class="method-con">
          <div class="img-name" :class="{ noClick: loadingShow }">
            <img :src="item.icon | imgPath" />
            <div class="line"></div>
            <span>{{ item.name }}</span>
          </div>

          <div class="money-num" :class="{ noClick: loadingShow }">
            <div class="money-discount-price">
              <i :class="{ actTextColor: loadingShow && item.name == selectPayName }">{{ item.currency }}</i>
              <span :class="{ actTextColor: loadingShow && item.name == selectPayName }">{{ handleDiv100(item.price) }}</span>
              <van-loading v-if="loadingShow && item.name == selectPayName" type="spinner" color="#FFFFFF" class="pay-loading" size="20px" />
            </div>
          </div>
        </div>
      </div>

      <!-- 不走接口-从客户端取 -->
      <GooglePay
        v-if="googleData[0]"
        :class="{ noClick: loadingShow }"
        :loadingShow="loadingShow"
        :price="googleData[0].price"
        :currency="googleData[0].currencyCode"
        @googlePay="originPay"
      />
    </div>

    <!-- 优惠劵列表popup -->
    <CouponPopup
      v-if="validCouponListSort"
      :active="couponTabActive"
      :showCouponPopup="showCoupon"
      :couponTabTit="couponTabTit"
      :maxCoupon="maxCoupon"
      :validCouponListSort="validCouponListSort"
      :expiredCouponList="expiredCouponList"
      :styleType="`for-${packageName}`"
      @confirmChooseCouponId="confirmChooseCouponId"
      @close="closeCouponPop"
    />

    <!-- 支付结果弹窗 -->
    <PayResult :showDiaC="showResultDia" :oneShow="true" :title="payResultText" />
  </div>
</template>

<script>
import { payMixin } from './mixins/pay.mixin.js'
import { couponMixin } from './mixins/coupon.mixin.js'

import GooglePay from './component/GooglePay.vue'
import PayResult from '@/components/CConfirm/PayResult.vue'
import CCouponEnter from '@/components/CCouponEnter'
import CCoupon from '@/components/CCoupon'

export default {
  mixins: [payMixin, couponMixin],
  components: {
    GooglePay,
    PayResult,
    CouponEnter: CCouponEnter,
    CouponPopup: CCoupon
  }
}
</script>

<style lang="scss" scoped>
/* 全局图片占位 */
img:not([src]) {
  opacity: 0;
}

/* .container-pay */
.container-pay {
  width: 100%;
  min-height: 100vh;
  background: #f7f6f9;
  padding-bottom: 80px;

  /* 顶部导航 */
  .custom-nav-block {
    background: #f7f6f9;

    .van-bar {
      ::v-deep .van-nav-bar__title {
        font-size: 17px;
        font-family: 'Inter-Bold', 'Inter-Regular';
        font-weight: bold;
        color: #333333;
      }
    }
  }

  .coin {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    padding: 0 10px;
    margin-right: -16px;
    background: #ffffff;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
    border-radius: 15px 0px 0px 15px;
    font-family: 'Inter-Regular';
    font-weight: 400;
    font-size: 11px;
    color: #333333;

    > img {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 4px;
    }

    > i {
      font-weight: 600;
      font-size: 17px;
      color: #a338fc;
    }
  }

  /* 主内容 .main */
  .main {
    margin-top: 20px;
    padding: 0 18px;

    .title {
      height: 20px;
      margin-bottom: 16px;
      font-size: 16px;
      font-family: 'Inter-Regular';
      font-weight: 500;
      color: #333333;
      line-height: 20px;
    }

    /* 充值档位 .recharge */
    .recharge {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .option {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 48%;
        margin-bottom: 20px;
        padding: 12px 0;
        color: #666666;
        background: #ffffff;
        border-radius: 8px;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        position: relative;

        .best-img {
          position: absolute;
          top: -12px;
          left: 0;
          width: 30px;
          height: 30px;
        }

        .option-top {
          width: 100%;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;

          .money-img {
            width: 24px;
            height: 24px;
            margin: 0 2px;
          }

          > span {
            display: inline-block;
            margin-bottom: 2px;
            font-size: 24px;
            font-family: 'Inter-Regular';
            font-weight: 600;
          }

          .add {
            font-size: 12px;
            color: #ff0000;
          }
        }

        .discount-num {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          column-gap: 2px;
          font-family: 'Inter-Regular';
          font-weight: 500;
          font-size: 10px;
          color: #ff0000;
          line-height: 12px;
          text-align: center;

          > span {
            display: flex;
            align-items: center;

            img {
              width: 10px;
              height: 10px;
              margin-left: 2px;
            }
          }

          .discount-num-tips {
            display: flex;
            align-items: center;
            width: fit-content;
            justify-content: center;
            height: 16px;
            margin-right: 2px;
          }
        }
      }

      .selectAct {
        color: #a338fc;
        outline: 2px solid #a338fc;
        border-radius: 8px;
      }
    }

    /* 优惠条（历史/备用样式） */
    .discount-box {
      position: relative;
      width: 100%;
      height: 66px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      background: url('~@/assets/packageAssets/views/P1_Boys/PayStore/default/discount_bg.png') no-repeat;
      background-size: 100% 100%;
      border-radius: 8px;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);

      .add-money {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }

      .add {
        min-width: 98px;
        height: 50px;
        margin-right: 5px;
      }

      .addRight {
        flex-direction: row-reverse;

        .add {
          .add-box {
            .add-discount {
              margin-left: 10px;
            }

            .add-box-bg {
              transform-origin: center center;
              transform: rotateY(180deg);
              -webkit-transform: rotateY(180deg);
              margin-left: 10px;
            }
          }
        }
      }

      .add-box {
        position: relative;
        width: 100%;
        height: 100%;
        padding: 0 20px;
        text-align: center;
        line-height: 50px;
        font-family: 'Inter-Regular';
        font-weight: 600;
        font-size: 22px;

        .add-discount {
          width: 100%;
          height: 100%;
          text-align: center;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 100;
          background: linear-gradient(41.47deg, #dc17f7 0%, #566bff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .add-box-bg {
          width: 100%;
          height: 100%;
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 50;
          background: url('~@/assets/packageAssets/views/P1_Boys/PayStore/default/arrow_yellow.png') no-repeat;
          background-size: 100% 100%;
        }
      }

      .money {
        display: flex;
        align-items: center;
        font-family: 'Inter-Regular';
        font-weight: 600;
        font-size: 28px;
        color: #fff64e;
        text-shadow: 0px 1px 1px rgba(90, 58, 8, 0.5);

        .icon-money {
          width: 42px;
          height: 42px;
        }
      }

      .method {
        width: 82px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-family: 'Inter-Regular';
        font-weight: 400;
        font-size: 9px;
        line-height: 12px;
        text-align: right;
        font-style: normal;
        color: #fff6db;
        background: linear-gradient(0deg, #fff6db 0%, #fdc58b 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

        .method-icon {
          display: flex;
          align-items: center;
          justify-content: center;

          > img {
            width: 12px;
            height: 12px;
            margin-right: 5px;
          }
        }

        .num {
          margin-top: 8px;
          font-size: 14px;
          text-align: center;
        }
      }
    }

    .loseSelect {
      opacity: 0.5;
    }

    /* 支付方式 .method-item */
    .method-item {
      width: 100%;
      margin-bottom: 10px;
      border-radius: 10px;

      &.has-dis-green {
        border: 1px solid #4caf50;

        .discount {
          background: #4caf50;
        }
      }

      &.has-dis-lightgreen {
        border: 1px solid #2dcd90;

        .discount {
          background: #2dcd90;
        }
      }

      &.activeLoading {
        pointer-events: none;
      }

      .discount {
        padding: 4px 10px;
        font-family: 'Outfit-Bold';
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        text-align: center;
        color: #ffffff;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }

      .method-con {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 56px;
        padding: 0 8px;
        background: #ffffff;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        font-size: 15px;
        font-family: 'Inter-Regular';
        font-weight: 600;

        .img-name {
          display: flex;
          align-items: center;

          > img {
            width: 54px;
            height: 32px;
            object-fit: contain;
          }

          > i {
            display: inline-block;
            height: 20px;
            margin: 0 5px;
            border-left: 1px solid #d8d8d8;
          }

          > span {
            color: #333333;
          }
        }

        .money-num {
          display: flex;
          align-items: center;
          font-size: 16px;

          > i {
            display: block;
            width: 20px;
            height: 20px;
            margin-left: 12px;
            border-radius: 50%;
            border: 0.5px solid #d8d8d8;
          }
        }

        .money-discount-price {
          position: relative;
          padding: 8px 5px;
          background: #424145;
          border-radius: 6px;
          color: #ffd786;
          font-family: 'Inter-Regular';
          text-align: center;

          > span {
            font-size: 15px;
          }

          > i {
            font-size: 8px;
          }
        }

        .pay-loading {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        .actTextColor {
          opacity: 0.1;
        }

        .noClick {
          pointer-events: none;
          filter: grayscale(100%);
        }
      }
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .container-pay .custom-nav-block .coin {
    margin-right: 0;
    margin-left: -16px;
    border-radius: 0px 15px 15px 0px !important;
  }

  .container-pay .custom-nav-block .coin > img {
    margin: 0 0 0 5px !important;
  }
}
</style>

<style>
.discount-coins {
  width: 14px;
  height: 14px;
}
</style>
